import { axios } from '../utils/http'

//获取资料完善进度 类型:设计sheJi、建筑shiGong、专家zhuanJia、其他qiTa
export const getImproveProgressNum = (type) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/information/getImproveProgressNum?type='+type)

//实名认证提交
export const certificationSubmit = (params) => axios({
  method: 'POST',
  contentType: 'json',
  data: {
    ...params
  },
  payHeader:true
}, '/user-api/information/certificationSubmit')

//人才认证提交
export const talentCertificationSubmit = (params) => axios({
  method: 'POST',
  contentType: 'json',
  data: {
    ...params
  },
  payHeader:true
}, '/user-api/information/talentCertificationSubmit')

//企业认证提交
export const enterpriseCertificationSubmit = (params) => axios({
  method: 'POST',
  contentType: 'json',
  data: {
    ...params
  },
  payHeader:true
}, '/user-api/enterprise/enterpriseCertificationSubmit')

//获取用户企业信息
export const getEnterpriseInfo = (type) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/enterprise/getEnterpriseInfo')

//个人所获得奖项-列表查询
export const awardsList = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/information/awardsList?'+params)

//个人所获得奖项-添加
export const awardsAdd = (params) => axios({
  method: 'POST',
  contentType: 'json',
  data: {
    ...params
  },
  payHeader:true
}, '/user-api/information/awardsAdd')

//个人所获得奖项-编辑
export const awardsEdit = (params) => axios({
  method: 'PUT',
  contentType: 'json',
  data: {
    ...params
  },
  payHeader:true
}, '/user-api/information/awardsEdit')

//个人所获得奖项-通过id查询
export const awardsDelete = (id) => axios({
  method: 'DELETE',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/information/awardsDelete?id='+id)

//个人所获得奖项-通过id查询
export const awardsQueryById = (id) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/information/awardsQueryById?id='+id)


//职业经历信息-列表查询
export const careerList = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/information/careerList?'+params)

//职业经历信息-添加
export const careerAdd = (params) => axios({
  method: 'POST',
  contentType: 'json',
  data: {
    ...params
  },
  payHeader:true
}, '/user-api/information/careerAdd')

//职业经历信息-编辑
export const careerEdit = (params) => axios({
  method: 'PUT',
  contentType: 'json',
  data: {
    ...params
  },
  payHeader:true
}, '/user-api/information/careerEdit')

//职业经历信息-通过id查询
export const careerDelete = (id) => axios({
  method: 'DELETE',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/information/careerDelete?id='+id)

//职业经历信息-通过id查询
export const careerQueryById = (id) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/information/careerQueryById?id='+id)


//发表论文-列表查询
export const dissertationList = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/information/dissertationList?'+params)

//发表论文-添加
export const dissertationAdd = (params) => axios({
  method: 'POST',
  contentType: 'json',
  data: {
    ...params
  },
  payHeader:true
}, '/user-api/information/dissertationAdd')

//发表论文-编辑
export const dissertationEdit = (params) => axios({
  method: 'PUT',
  contentType: 'json',
  data: {
    ...params
  },
  payHeader:true
}, '/user-api/information/dissertationEdit')

//发表论文-通过id查询
export const dissertationDelete = (id) => axios({
  method: 'DELETE',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/information/dissertationDelete?id='+id)

//发表论文-通过id查询
export const dissertationQueryById = (id) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/information/dissertationQueryById?id='+id)


//学历信息-列表查询
export const educationList = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/information/educationList?'+params)

//学历信息-添加
export const educationAdd = (params) => axios({
  method: 'POST',
  contentType: 'json',
  data: {
    ...params
  },
  payHeader:true
}, '/user-api/information/educationAdd')

//学历信息-编辑
export const educationEdit = (params) => axios({
  method: 'PUT',
  contentType: 'json',
  data: {
    ...params
  },
  payHeader:true
}, '/user-api/information/educationEdit')

//学历信息-通过id查询
export const educationDelete = (id) => axios({
  method: 'DELETE',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/information/educationDelete?id='+id)

//学历信息-通过id查询
export const educationQueryById = (id) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/information/educationQueryById?id='+id)


//培训经历信息-列表查询
export const experienceList = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/information/experienceList?'+params)

//培训经历信息-添加
export const experienceAdd = (params) => axios({
  method: 'POST',
  contentType: 'json',
  data: {
    ...params
  },
  payHeader:true
}, '/user-api/information/experienceAdd')

//培训经历信息-编辑
export const experienceEdit = (params) => axios({
  method: 'PUT',
  contentType: 'json',
  data: {
    ...params
  },
  payHeader:true
}, '/user-api/information/experienceEdit')

//培训经历信息-通过id查询
export const experienceDelete = (id) => axios({
  method: 'DELETE',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/information/experienceDelete?id='+id)

//培训经历信息-通过id查询
export const experienceQueryById = (id) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/information/experienceQueryById?id='+id)


//主要项目业绩情况-列表查询
export const performanceList = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/information/performanceList?'+params)

//主要项目业绩情况-添加
export const performanceAdd = (params) => axios({
  method: 'POST',
  contentType: 'json',
  data: {
    ...params
  },
  payHeader:true
}, '/user-api/information/performanceAdd')

//主要项目业绩情况-编辑
export const performanceEdit = (params) => axios({
  method: 'PUT',
  contentType: 'json',
  data: {
    ...params
  },
  payHeader:true
}, '/user-api/information/performanceEdit')

//主要项目业绩情况-通过id查询
export const performanceDelete = (id) => axios({
  method: 'DELETE',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/information/performanceDelete?id='+id)

//主要项目业绩情况-通过id查询
export const performanceQueryById = (id) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/information/performanceQueryById?id='+id)


//上岗证信息-列表查询
export const permitList = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/information/permitList?'+params)

//上岗证信息-添加
export const permitAdd = (params) => axios({
  method: 'POST',
  contentType: 'json',
  data: {
    ...params
  },
  payHeader:true
}, '/user-api/information/permitAdd')

//上岗证信息-编辑
export const permitEdit = (params) => axios({
  method: 'PUT',
  contentType: 'json',
  data: {
    ...params
  },
  payHeader:true
}, '/user-api/information/permitEdit')

//上岗证信息-通过id查询
export const permitDelete = (id) => axios({
  method: 'DELETE',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/information/permitDelete?id='+id)

//上岗证信息-通过id查询
export const permitQueryById = (id) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/information/permitQueryById?id='+id)


//执业资格信息-列表查询
export const requirementsList = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/information/requirementsList?'+params)

//执业资格信息-添加
export const requirementsAdd = (params) => axios({
  method: 'POST',
  contentType: 'json',
  data: {
    ...params
  },
  payHeader:true
}, '/user-api/information/requirementsAdd')

//执业资格信息-编辑
export const requirementsEdit = (params) => axios({
  method: 'PUT',
  contentType: 'json',
  data: {
    ...params
  },
  payHeader:true
}, '/user-api/information/requirementsEdit')

//执业资格信息-通过id查询
export const requirementsDelete = (id) => axios({
  method: 'DELETE',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/information/requirementsDelete?id='+id)

//执业资格信息-通过id查询
export const requirementsQueryById = (id) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/information/requirementsQueryById?id='+id)


//职称信息-列表查询
export const titleList = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/information/titleList?'+params)

//职称信息-添加
export const titleAdd = (params) => axios({
  method: 'POST',
  contentType: 'json',
  data: {
    ...params
  },
  payHeader:true
}, '/user-api/information/titleAdd')

//职称信息-编辑
export const titleEdit = (params) => axios({
  method: 'PUT',
  contentType: 'json',
  data: {
    ...params
  },
  payHeader:true
}, '/user-api/information/titleEdit')

//职称信息-通过id查询
export const titleDelete = (id) => axios({
  method: 'DELETE',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/information/titleDelete?id='+id)

//职称信息-通过id查询
export const titleQueryById = (id) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/information/titleQueryById?id='+id)


//过往项目信息-列表查询
export const projectList = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/enterprise/projectList?'+params)

//过往项目信息-添加
export const projectAdd = (params) => axios({
  method: 'POST',
  contentType: 'json',
  data: {
    ...params
  },
  payHeader:true
}, '/user-api/enterprise/projectAdd')

//过往项目信息-编辑
export const projectEdit = (params) => axios({
  method: 'PUT',
  contentType: 'json',
  data: {
    ...params
  },
  payHeader:true
}, '/user-api/enterprise/projectEdit')

//过往项目信息-通过id查询
export const projectDelete = (id) => axios({
  method: 'DELETE',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/enterprise/projectDelete?id='+id)

//过往项目信息-通过id查询
export const projectQueryById = (id) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/enterprise/projectQueryById?id='+id)


//企业资质情况-列表查询
export const qualificationList = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/enterprise/qualificationList?'+params)

//企业资质情况-添加
export const qualificationAdd = (params) => axios({
  method: 'POST',
  contentType: 'json',
  data: {
    ...params
  },
  payHeader:true
}, '/user-api/enterprise/qualificationAdd')

//企业资质情况-编辑
export const qualificationEdit = (params) => axios({
  method: 'PUT',
  contentType: 'json',
  data: {
    ...params
  },
  payHeader:true
}, '/user-api/enterprise/qualificationEdit')

//企业资质情况-通过id查询
export const qualificationDelete = (id) => axios({
  method: 'DELETE',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/enterprise/qualificationDelete?id='+id)

//企业资质情况-通过id查询
export const qualificationQueryById = (id) => axios({
  method: 'GET',
  contentType: 'urlencoded',
  payHeader:true
}, '/user-api/enterprise/qualificationQueryById?id='+id)


// WEBPACK FOOTER //
// ./src/api/tableapi.js